export default __webpack_public_path__ + "static/media/building_websites.dcb51374.svg";